import { makeUUID } from '$lib/factories'

import { type OpenaiThreadItem } from './types'


export function makeOpenaiThreadItem(params: Partial<OpenaiThreadItem>): OpenaiThreadItem {
	
	return {
		id: makeUUID(),
		account_id: params.account_id || '',
		thread_id: params.thread_id || '',
		question: params.question || '',
		response: params.response || '',
		tokens: params.tokens || 0,
		craeted_at: params.craeted_at || 0
	}
}	